import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "inline-flex items-center justify-center h-6"
};
import { Country } from "@/modules/base/entity";
import { CountryEnum } from "@/modules/base/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'Flag',
  props: {
    country: null
  },
  setup(__props) {
    const props = __props;
    const title = computed(() => props.country instanceof Country ? props.country.name : props.country);
    const flagUrl = computed(() => {
      // @ts-ignore
      const code = Object.keys(CountryEnum).find(key => CountryEnum[key] === title.value);
      return `/flags/country-${code.toLowerCase()}.svg`;
    });
    return (_ctx, _cache) => {
      const _component_NImage = _resolveComponent("NImage");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NImage, {
        "preview-disabled": "",
        "object-fit": "cover",
        width: 28,
        height: 28,
        radius: 2,
        src: _unref(flagUrl),
        alt: _unref(title),
        title: _unref(title)
      }, null, 8, ["src", "alt", "title"])]);
    };
  }
});